import gql from 'graphql-tag'

const BatchUpdateTasks = gql`
  mutation BatchUpdateTasks($input: BatchUpdateTasksMutationInput!) {
    batchUpdateTasks(input: $input) {
      tasks {
        id
        claimId
        status
        description
        priority
        createdAt
        user {
          id
          name
          surname
        }
        claim {
          id
          state
        }
      }
    }
  }
`;

export { BatchUpdateTasks }


// WEBPACK FOOTER //
// ./src/mutations/BatchUpdateTasks.js